import { GGSCountryController } from './../../../language/countryMapper/GGSCountryController';

import { EnvGlobalsHandler } from "../../EnvGlobalsHandler";
import { BasicSmartfoxConstants } from "../BasicSmartfoxConstants";
import { BasicModel } from "../../model/BasicModel";
import { SimpleCommand } from './../../../commanding/SimpleCommand';


export class BasicRegisterJsonCommand extends SimpleCommand {
    public execute(commandVars: any = null): void {
        let params: any[] = (<any[]>commandVars);
        let email: string = params.shift();
        let password: string = params.shift();
        let paramObject: any = (<any>params.shift());

        paramObject.mail = email;
        paramObject.pw = password;
        paramObject.referrer = EnvGlobalsHandler.globals.cleanReferrer;
        paramObject.lang = GGSCountryController.instance.currentCountry.ggsLanguageCode;
        paramObject.did = EnvGlobalsHandler.globals.distributorId;
        paramObject.connectTime = BasicModel.smartfoxClient.connectionTime;
        paramObject.ping = BasicModel.smartfoxClient.roundTripTime;
        paramObject.accountId = EnvGlobalsHandler.globals.accountId;
        paramObject.campainPId = parseInt(EnvGlobalsHandler.globals.campainVars.partnerId);
        paramObject.campainCr = parseInt(EnvGlobalsHandler.globals.campainVars.creative);
        paramObject.campainPl = EnvGlobalsHandler.globals.campainVars.placement;
        paramObject.campainKey = EnvGlobalsHandler.globals.campainVars.keyword;
        paramObject.campainNW = EnvGlobalsHandler.globals.campainVars.network;
        paramObject.campainLP = parseInt(EnvGlobalsHandler.globals.campainVars.lp);
        paramObject.campainCId = EnvGlobalsHandler.globals.campainVars.channelId;
        paramObject.campainTS = EnvGlobalsHandler.globals.campainVars.trafficSource;
        paramObject.adid = parseInt(EnvGlobalsHandler.globals.campainVars.aid);
        paramObject.camp = EnvGlobalsHandler.globals.campainVars.camp;
        paramObject.adgr = EnvGlobalsHandler.globals.campainVars.adgr;
        paramObject.matchtype = EnvGlobalsHandler.globals.campainVars.matchtype;

        BasicModel.smartfoxClient.sendMessage(BasicSmartfoxConstants.C2S_REGISTER, [JSON.stringify(paramObject)]);
        BasicModel.userData.loginPwd = password;
    }
}
